import type { LoadableType } from '@confluence/loadable';
import { LoadableLazy } from '@confluence/loadable';

export const ChangesDiffLoader: LoadableType<{
	contentId: string;
}> = LoadableLazy({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-ChangesDiff" */ './ChangesDiff.tsx')).ChangesDiff,
});
